import { LeadStatus } from '@shared-features/enums/lead-status.enum';
import { Country } from './country';
import { Model } from './model';
import { Expose, Type } from 'class-transformer';
import { User } from '@features/users/models/user';

export class Lead extends Model {
  @Expose() id: number;
  @Expose() mobileNumber: string;
  @Expose() isMobileNumberVerified: boolean;
  @Expose() createdAt: number;
  @Expose() updatedAt: number;
  @Expose() latitude: number;
  @Expose() longitude: number;
  @Expose() nationality: Country;
  @Expose() status: LeadStatus;
  @Expose() updatedBy: User;

  @Expose() get latlng(): any {
    return {
      lat: this.latitude,
      lng: this.longitude,
    };
  }
}

export class FreelancerLeads extends Model {
  @Expose()
  @Type(() => Lead)
  leads: Lead[];

  @Expose() count: number;
  @Expose() fileUri: string;
}